import { Resource } from '../../../common/constants/resource';

export const formatLocation = (
  address: string,
  city: string,
  state: string,
  zipcode: string,
): string => {
  const cityStateZip = [city, [state, zipcode].filter(Boolean).join(' ')]
    .map(p => p.trim())
    .filter(Boolean)
    .join(', ');
  return [cityStateZip, address].filter(Boolean).join(', ');
};

export const valueToString = (value: boolean | number | string | undefined) => {
  return value !== undefined && value !== ''
    ? String(value)
    : Resource.NORA_M_DASH;
};
